import React from "react";

const Applications = (props) => {
	return <div>{props.children}</div>;
};

export default Applications;
